import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/admin', pathMatch: 'full' },
  { path: 'admin', loadChildren: () => import('./admin/admin-routing').then(m => m.adminRoutes) }
  // {
  //   path: "",
  //   loadChildren: () => import('./admin/admin-routing').then(m => m.adminRoutes)
  // }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})

export class AppRoutingModule {
}
